<template>
    <div class="working">
        <h1>机组实时工况</h1>
        <div class="line"></div>
        <!-- 下拉列表 -->
        <div class="tab">
            <el-select v-model="value">
                <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="card">
            <div class="top">
                <div>
                    <div class="title">进水温度</div>
                    <div class="text">
                        <div>{{ items[0].val }}</div>
                        <div>℃</div>
                    </div>
                </div>
                <p></p>
                <div>
                    <div class="title">出水温度</div>
                    <div class="text">
                        <div>{{ items[1].val }}</div>
                        <div>℃</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div>
                    <div class="title">进水压力</div>
                    <div class="text">
                        <div>{{ items[2].val }}</div>
                        <div>MPa</div>
                    </div>
                </div>
                <p></p>
                <div>
                    <div class="title">出水压力</div>
                    <div class="text">
                        <div>{{ items[3].val }}</div>
                        <div>MPa</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
export default {
    data() {
        return {
            // 下拉选择框
            options: [
                {
                    value: 1,
                    label: "#1蒸发器侧",
                    names: "en_1.PV,en_2.PV,en_29.PV,en_30.PV",
                },
                {
                    value: 2,
                    label: "#1冷凝器侧",
                    names: "en_3.PV,en_4.PV,en_31.PV,en_32.PV",
                },
                {
                    value: 3,
                    label: "#2蒸发器侧",
                    names: "en_5.PV,en_6.PV,en_33.PV,en_34.PV",
                },
                {
                    value: 4,
                    label: "#2冷凝器侧",
                    names: "en_7.PV,en_8.PV,en_35.PV,en_36.PV",
                },
                {
                    value: 5,
                    label: "#3蒸发器侧",
                    names: "en_9.PV,en_10.PV,en_37.PV,en_38.PV",
                },
                {
                    value: 6,
                    label: "#3冷凝器侧",
                    names: "en_11.PV,en_12.PV,en_39.PV,en_40.PV",
                },
                {
                    value: 7,
                    label: "#4蒸发器侧",
                    names: "en_13.PV,en_14.PV,en_41.PV,en_42.PV",
                },
                {
                    value: 8,
                    label: "#4冷凝器侧",
                    names: "en_15.PV,en_16.PV,en_43.PV,en_44.PV",
                },
            ],
            value: 1,
            items: [
                {
                    "name": "en_3.PV",
                    "val": 0
                },
                {
                    "name": "en_4.PV",
                    "val": 0
                },
                {
                    "name": "en_31.PV",
                    "val": 0
                },
                {
                    "name": "en_32.PV",
                    "val": 0
                }
            ]
        };
    },
    mounted() {
        this.handleGetData();
        this.handleAdd()
    },
    methods: {
        // 获取数据
        handleGetData() {
            getRequest("/api/realdata", {
                names: this.options[this.value - 1].names,
                token: sessionStorage.getItem("realTimeToken"),
                decimal: 2,
            }).then((res) => {
                if (res.code == 0) {
                    this.items = res.items;
                }
            })
        },
        handleAdd() {
            setInterval(() => {
                this.value += 1;
                if (this.value == this.options.length + 1) {
                    this.value = 1;
                }
            }, 1000 * 60*5)
        },
    },
    watch: {
        value(newVal) {
            this.handleGetData();
        }
    }
};
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face {
    /*自定义文字名称*/
    font-family: "yj";
    /*字体文件的路径*/
    src: url("./1.TTF");
}

.working::v-deep {
    height: 200px;

    h1 {
        margin: 15px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005ec9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .tab {
        display: flex;
        justify-content: flex-end;
        margin: 4px 0 0;

        input {
            text-align: center;
            margin: 0 5px;
            width: 90px;
            height: 20px;
            box-sizing: border-box;
            background: linear-gradient(122deg, #0f65ea 0%, #00d9ea 100%);
            font-size: 14px;
            font-weight: 600;
            color: #ffffff;
            line-height: 20px;
            padding: 0 10px 0 5px;
            border-radius: 0px;
            border: none;

        }
    }

    .card {
        margin-top: 4px;

        .top,
        .bottom {
            margin-bottom: 15px;
            height: 55px;
            display: flex;
            align-items: flex-end;
            justify-content: space-evenly;

            >div {

                .title {
                    height: 18px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 18px;
                }

                .text {
                    display: flex;
                    width: 120px;
                    height: 37px;
                    justify-content: space-between;
                    align-items: flex-end;
                    padding-bottom: 10px;

                    div {
                        &:nth-child(1) {
                            font-size: 30px;
                            font-weight: 600;
                            color: #00fff2;
                            /*使用刚才定义的字体名称*/
                            font-family: yj;
                        }

                        &:nth-child(2) {
                            width: 30px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #00fff2;
                        }
                    }
                }
            }

            >p {
                width: 0;
                height: 40px;
                border: 1px solid rgba(62, 255, 244, 0.41);
            }
        }
    }

    .el-input__icon {
        line-height: 20px;
    }
}
</style>